import { render, staticRenderFns } from "./TheBreadCrumbs.vue?vue&type=template&id=8c4785de&scoped=true"
import script from "./TheBreadCrumbs.vue?vue&type=script&lang=js"
export * from "./TheBreadCrumbs.vue?vue&type=script&lang=js"
import style0 from "./TheBreadCrumbs.vue?vue&type=style&index=0&id=8c4785de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4785de",
  null
  
)

export default component.exports